module.exports = __webpack_public_path__ + "static/media/coffee_tea.cdd37211.svg";